var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0781 8.375C20.0781 12.8633 15.6016 16.5 10.0781 16.5C8.62891 16.5 7.2539 16.25 6.01172 15.8008C5.54687 16.1406 4.78906 16.6055 3.89062 16.9961C2.95312 17.4023 1.82422 17.75 0.703124 17.75C0.449217 17.75 0.222655 17.5977 0.124999 17.3633C0.0273425 17.1289 0.08203 16.8633 0.257811 16.6836L0.26953 16.6719C0.281249 16.6602 0.296874 16.6445 0.320311 16.6172C0.36328 16.5703 0.429686 16.4961 0.511717 16.3945C0.671874 16.1992 0.886717 15.9102 1.10547 15.5508C1.49609 14.9023 1.86719 14.0508 1.94141 13.0938C0.76953 11.7656 0.0781237 10.1367 0.0781237 8.375C0.0781237 3.88672 4.55469 0.25 10.0781 0.25C15.6016 0.25 20.0781 3.88672 20.0781 8.375Z",
    fill: "#3C1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoIcon);
export default __webpack_public_path__ + "static/media/kakao_icon.24494855cebfb9cfc6ffbf61df203046.svg";
export { ForwardRef as ReactComponent };